'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Calculate element’s offsetTop relative to document
 * @param {Element} el
 * @returns {number} offset
 */
function documentOffsetTop(el, _offset) {
  var offset = _offset || 0;

  if (!el || !el.offsetParent || isNaN(el.offsetTop)) {
    return offset;
  }

  return documentOffsetTop(el.offsetParent, offset + el.offsetTop);
}

exports.documentOffsetTop = documentOffsetTop;
//# sourceMappingURL=document-offset-top.js.map
